// src/components/OrgStructureDialog.tsx
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog"
import { Crown, Bomb, Sword, Zap, Shield, ChevronDown } from "lucide-react"

interface OrgStructureDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export default function OrgStructureDialog({ open, onOpenChange }: OrgStructureDialogProps) {
  return (
    <DialogContent className="bg-slate-950 border-purple-800 text-white max-w-5xl w-full h-fit overflow-visible">
      <DialogHeader className="pb-2">
        <DialogTitle className="text-3xl font-bold text-center bg-gradient-to-r from-yellow-400 via-purple-400 to-indigo-400 bg-clip-text text-transparent">
          СТРУКТУРА ОРВ ВСКС
        </DialogTitle>
      </DialogHeader>

      <div className="mt-0 space-y-6">

        {/* АНДРЕЕВ — Заместитель руководителя */}
        <div className="flex justify-center">
          <div className="relative group">
            <div className="absolute inset-0 bg-yellow-500/30 blur-3xl rounded-full group-hover:blur-4xl transition"></div>
            <div className="relative bg-gradient-to-br from-yellow-700 to-orange-800 p-6 rounded-3xl border-4 border-yellow-500 shadow-2xl">
              <Crown className="h-16 w-16 mx-auto mb-4 text-yellow-300" />
              <p className="text-xl font-bold text-center text-yellow-100">Заместитель руководителя</p>
              <p className="text-2xl font-extrabold text-center mt-3">Андреев Алексей Евгеньевич</p>
            </div>
          </div>
        </div>

        <ChevronDown className="h-10 w-10 mx-auto text-purple-500 animate-bounce" />

        {/* БАГАУТДИНОВ — Начальник отдела */}
        <div className="flex justify-center">
          <div className="relative group">
            <div className="absolute inset-0 bg-red-500/30 blur-3xl rounded-full group-hover:blur-4xl transition"></div>
            <div className="relative bg-gradient-to-br from-red-800 to-orange-900 p-6 rounded-3xl border-4 border-red-500 shadow-2xl">
              <Bomb className="h-16 w-16 mx-auto mb-4 text-red-300" />
              <p className="text-xl font-bold text-center text-red-100">Начальник отдела</p>
              <p className="text-2xl font-extrabold text-center mt-3">Багаутдинов Ахмет Айратович</p>
            </div>
          </div>
        </div>

        <ChevronDown className="h-10 w-10 mx-auto text-purple-500 animate-bounce" />

        {/* БАРЛАДЯН и ПАВЛИК — Заместители начальника */}
        <div className="grid grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Барладян — Меч */}
          <div className="text-center">
            <div className="bg-gradient-to-br from-pink-900 to-purple-900 p-6 rounded-2xl border-2 border-pink-600 hover:scale-105 transition">
              <Sword className="h-12 w-12 mx-auto mb-4 text-pink-300" />
              <p className="text-lg font-bold text-pink-300">Заместитель начальника</p>
              <p className="text-xl font-bold mt-3">Барладян Ирина Алексеевна</p>
            </div>
          </div>

          {/* Павлик — Молния */}
          <div className="text-center">
            <div className="bg-gradient-to-br from-purple-900 to-violet-900 p-6 rounded-2xl border-2 border-purple-600 hover:scale-105 transition">
              <Zap className="h-12 w-12 mx-auto mb-4 text-purple-300" />
              <p className="text-lg font-bold text-purple-300">Заместитель начальника</p>
              <p className="text-xl font-bold mt-3">Павлик Кристина Валентиновна</p>
            </div>
          </div>
        </div>

        <ChevronDown className="h-10 w-10 mx-auto text-purple-500 animate-bounce" />

        {/* СПЕЦИАЛИСТЫ */}
        <div className="grid grid-cols-3 gap-6 max-w-4xl mx-auto">
          {/* Казарин */}
          <div className="text-center group hover:scale-110 transition">
            <div className="bg-gradient-to-br from-green-600 to-emerald-700 p-6 rounded-2xl border-2 border-white/20">
              <Shield className="h-10 w-10 mx-auto mb-4 text-green-300" />
              <p className="text-lg font-bold">Специалист</p>
              <p className="text-xl font-bold mt-3">Казарин Сергей Константинович</p>
            </div>
          </div>

          {/* Султанова */}
          <div className="text-center group hover:scale-110 transition">
            <div className="bg-gradient-to-br from-cyan-600 to-blue-700 p-6 rounded-2xl border-2 border-white/20">
              <Shield className="h-10 w-10 mx-auto mb-4 text-cyan-300" />
              <p className="text-lg font-bold">Специалист</p>
              <p className="text-xl font-bold mt-3">Султанова Диана Рашитовна</p>
            </div>
          </div>

          {/* Степанушкин */}
          <div className="text-center group hover:scale-110 transition">
            <div className="bg-gradient-to-br from-amber-600 to-orange-700 p-6 rounded-2xl border-2 border-white/20">
              <Shield className="h-10 w-10 mx-auto mb-4 text-amber-300" />
              <p className="text-lg font-bold">Специалист</p>
              <p className="text-xl font-bold mt-3">Степанушкин Сергей Вадимович</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-6 pb-2">
          <p className="text-4xl font-extrabold bg-gradient-to-r from-purple-400 via-pink-400 to-yellow-400 bg-clip-text text-transparent">
            ОРВ ВСКС — СИЛА!
          </p>
        </div>
      </div>
    </DialogContent>
  )
}